import { render, staticRenderFns } from "./CourseGeneral.vue?vue&type=template&id=7a0c3de8&"
import script from "./CourseGeneral.vue?vue&type=script&lang=js&"
export * from "./CourseGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports